import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Nan = props => {
  var {
    Nan: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Nan');
  return null;
};
Nan.displayName = 'JVR.Nan';